import React, { useState } from 'react';
import Navbar from '../../containers/Navbar/Navbar';
import {useDispatch} from 'react-redux';
import {forgotPassword} from '../../../redux/actions/authActions';
import CircularSpinner from '../../utils/CircularSpinner';
import style from './ForgotPassword.module.css';

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [success, setSuccess] = useState("");
    const [failure, setFailure] = useState("");

    const dispatch = useDispatch();

    const emailSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        const data = {
            email: email,
        }
        const response = await dispatch(forgotPassword(data));

        if(response.status === 200){
            setSuccess("Email successfully sent");
            setFailure("");
        }else{
            const errorMessage = response.data.errorMessage || "Something went wrong !!"
            setFailure(errorMessage);
            setSuccess("");
        }
        setEmail("");
        setIsLoading(false);
    }

    return (
        <div className='w-100'>
            <Navbar />
            <div className={`${style.loginForm} w-50 mx-auto p-5`}>
                <h3 className='text-center'>
                    Forgot Password Form
                </h3>
                {
                    success ? 
                    (
                         <div className="alert alert-success alert-dismissible fade show" role="alert">
                            {success}
                            <button type="button"  onClick = {() => setSuccess("")} className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div>
                    ) : 
                    <></>
                }
                 {
                    failure ? 
                    (
                        <div className="alert alert-danger alert-dismissible fade show" role="alert">
                        {failure}
                        <button type="button" onClick = {() => setFailure("")} className="btn-close" data-bs-dismiss="alert" aria-label="Close">

                        </button>
                    </div>
                    ) : 
                    <></>
                }
                <form onSubmit={emailSubmit}>
                    <div className='form-group mt-5'>
                        <input className="form-control w-100" 
                        type='email' 
                        placeholder="Enter your email id"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <div className='form-group mt-5'>
                        <button className='btn btn-primary w-100' disabled={isLoading}>
                            {
                                isLoading ?
                                <CircularSpinner /> :
                                <div>Submit</div>
                            }
                        </button>
                    </div>
                </form>
            </div>
        </div>
    )
}

export default ForgotPassword
